import { render } from "./itemScroll.vue?vue&type=template&id=8197f724&scoped=true"
const script = {}

import "./itemScroll.vue?vue&type=style&index=0&id=8197f724&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8197f724"]])

export default __exports__